import {
  getIsApplicantFieldMasked,
  getRentalPortalApplicantIdentityLabel,
} from '../../../RentalPortalApplicant'

import { APPLICANT_PROFILE_DOCUMENTS_BREADCRUMB_APPLICANT } from './RentalPortalApplicantProfileDocuments.constants'

export function getApplicantDocumentsRootBreadcrumbs({ applicantData, t }) {
  return [
    {
      id: APPLICANT_PROFILE_DOCUMENTS_BREADCRUMB_APPLICANT,
      title: getRentalPortalApplicantIdentityLabel({
        applicant: applicantData,
        t,
      }),
    },
  ]
}

export function getIsApplicantDocumentsFolderAvailable(applicantData) {
  return (
    !getIsApplicantFieldMasked(applicantData?.identity) &&
    Boolean(applicantData?.directory_id)
  )
}

export function getApplicantDocumentsFolderEmptyKey(applicantData) {
  return getIsApplicantFieldMasked(applicantData?.identity)
    ? 'RentalPortal.ApplicantProfileDocumentsMaskedEmptyKey'
    : 'RentalPortal.ApplicantProfileDocumentsNoFolderKey'
}
